module.exports = __webpack_public_path__ + "static/img/logo-animatable.ef729b6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-animatable.svg
// module id = qFUb
// module chunks = 0